import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {getTaskRelatedObjectsData} from '../../components/Common/TaskAttributes/ListGroupedDataSelector';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskRelatedObjectReducer(state = initialState.taskRelatedObject, action) {
	switch (action.type) {
		case types.GET_TASK_RELATED_OBJECT: {
			let taskRelatedObject = action.response.components;
			taskRelatedObject.taskRelatedObjectData = getTaskRelatedObjectsData(action.response.components);
			return {...taskRelatedObject};
		}
		case types.EDIT_TASK_TITLE: {
			const availablePathForPatchOpr = [
				'updatecontrol',
				'updateitcontrol',
				'updateITControlDesignEffectiveness',
				'updateControlDesignEffectiveness'
			];
			if (action?.payload && availablePathForPatchOpr.includes(action.payload?.path)) {
				return {...state, payload: action.payload};
			}

			return state;
		}
		case types.RESET_TASK_DETAIL:
		case types.RESET_TASK_ATTRIBUTES:
			return initialState.taskRelatedObject;
		default:
			return state;
	}
}
